export const valueChangeEvent = (name: string) => `${name}_VALUE_CHANGE`;
